<template>
  <div class="home-content-page-v prediction-car-page">
    <div class="two-content">
      <div class="content-1-1 mii-table">
        <content-title title="每日订单（9月14日）"></content-title>
        <table style="width: 100%;background: #fff;">
          <thead>
            <tr>
              <th>订单名称</th>
              <th>加油站</th>
              <th>日期</th>
              <th>订单类型</th>
              <th>油品</th>
              <th>罐号</th>
              <th>空容</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data, index) in showData.slice(start_index, start_index + row_num)">
              <td :class="{'s-bak-td': index % 3 === 1}" style="width:8em;">{{'订单' + (start_index + index + 1)}}</td>
              <td v-for="(value, vIndex) in data.slice(0, 6)" :class="{'s-bak-td': index % 3 === 1}">
                <span>{{value === null ? '' : value}}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="content-1-page">
          <el-pagination small v-on:current-change="pageChange" :page-size="row_num" :total="showData.length" @size-change="handleSizeChange" :page-sizes="[7, 10, 20, 50]" layout="sizes, prev, pager, next">
          </el-pagination>

        </div>
      </div>
      <div class="content-1-2 mii-table">
        <div class="table-tool">
          <a href="javascript:;">
            <i class="iconfont icon-daochu" @click="optPutFile"></i>
          </a>
        </div>
        <content-title title="运送车辆"></content-title>
        <table style="width: 100%;background: #fff;">
          <thead>
            <tr>
              <th>车号</th>
              <th>所用车辆仓号</th>
              <th>仓容积</th>
              <th>不容纳时间点</th>
              <th>断货时间点</th>
              <th>预计发车时间</th>
              <th>在途时间</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data, index) in showData.slice(start_index, start_index + row_num)">
              <td v-for="(value, vIndex) in data.slice(6)" :class="{'s-bak-td': index % 3 === 1, 'car-data-id': vIndex===0}">
                <span>{{value === null ? '' : value}}</span>
                <template v-if="vIndex===0">
                  <a href="javascript:;" @click="changeCar(index)">
                    <i class="iconfont icon-change"></i>
                  </a>
                  <div class="select-cars" :class="{'show-search': change_index === index && !chat}">
                    <div class="select-cars-search">
                      <el-input v-model="search_car" size="mini" placeholder="车牌"></el-input>
                      <a href="javascript:;" @click="change_index=-1">X</a>
                    </div>
                    <div class="cars-infos-th">
                      <div>配送</div>
                      <div>车号</div>
                      <div>最大装载量</div>
                      <div>罐车仓数</div>
                      <div>1号仓容积</div>
                      <div>2号仓容积</div>
                      <div>3号仓容积</div>
                      <div>4号仓容积</div>
                    </div>
                    <div class="cars-infos-div">
                      <a class="cars-infos" @click="changeOneData(start_index + index, car[1])" href="javascript:;" v-for="car in showOptions">
                        <div v-for="info in car">
                          {{info}}
                        </div>
                      </a>                      
                    </div>
                  </div>
                </template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="content-2">
      <div class="chat-title">
        图表展示
      </div>
      <div class="chat-block">
        <div class="chat-content">
          <div class="chat-y">
            <div class="chat-y-line">
              <div class="y-top-note" style="text-align: right">
                <span class="">订单</span>
              </div>
              <div class="one-y" v-for="data in charData">{{data.name}}</div>
            </div>
            <div class="chat-y-data">
              <div class="data-one" v-for="data in charData">
                <div class="data-xian data-first-xian" :style="data.style1">
                  <div class="data-none">
                  </div>
                </div>
                <div class="data-xian">
                  <div class="data-num data-brn">
                    <div class="data-brn-note">
                      不容纳时间点<br>
                      {{data.dh_date}}
                    </div>
                  </div>
                </div>
                <div class="data-xian data-xian-sned">
                  <div class="data-num data-send">
                    <div class="data-brn-note">
                      不容纳时间点 - 断货时间点<br>
                      {{data.dh_date}} - {{data.brn_date}}
                    </div>
                  </div>
                </div>
                <div class="data-xian">
                  <div class="data-num data-dh">
                    <div class="data-brn-note">
                      断货时间点<br>
                      {{data.brn_date}}
                    </div>
                  </div>
                </div>
                <div class="data-xian" :style="data.style2">
                  <div class="data-none">
                  </div>
                </div>
              </div>
            </div>
            <div class="car-data">
              <div class="one-car-data" v-for="(data, index) in showData.slice(start_index, start_index + row_num)">
                {{data[6]}}
                <a href="javascript:;" @click="changeCar(index, true)">
                  <i class="iconfont icon-change"></i>
                </a>
                <div class="select-cars" :class="{'show-search': change_index === index && chat}">
                  <div class="select-cars-search">
                    <el-input v-model="search_car" size="mini" placeholder="车牌"></el-input>
                    <a href="javascript:;" @click="change_index=-1">X</a>
                  </div>
                  <div class="cars-infos-th">
                    <div>配送</div>
                    <div>车号</div>
                    <div>最大装载量</div>
                    <div>罐车仓数</div>
                    <div>1号仓容积</div>
                    <div>2号仓容积</div>
                    <div>3号仓容积</div>
                    <div>4号仓容积</div>
                  </div>
                  <div class="cars-infos-div">
                    <a class="cars-infos" @click="changeOneData(start_index + index, car[1])" href="javascript:;" v-for="car in showOptions">
                      <div v-for="info in car">
                        {{info}}
                      </div>
                    </a>                      
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="chat-x">
            <div class="one-x">
              09.13
            </div>
            <div class="one-x">
              09.14
            </div>
            <div class="one-x one-x-last">
              09.15
            </div>
            <div style="text-align: right;">
              <span class="y-top-note">时间</span>
            </div>
          </div>
        </div>
        <div class="chat-info">
          <div class="one-info">
            <div class="dian dian-1">
            </div>
            <span>可送货窗口</span>
          </div>
          <div class="one-info">
            <div class="dian dian-2">
            </div>
            <span>不容纳缓冲</span>
          </div>
          <div class="one-info">
            <div class="dian dian-3">
            </div>
            <span>断货缓冲</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContentTitle from '../components_bit/ContentTitle'
import {
  outPutExcelFile
} from '../cllib'
export default {
  data () {
    return {
      chat: false,
      quy: '昆明',
      start_index: 0,
      row_num: 7,
      change_index: -1,
      search_car: '',
      show_more: false
    }
  },
  components: {
    ContentTitle
  },
  methods: {
    optPutFile () {
      let datas = [{
        data: [],
        sheetName: 'data1'
      }]
      let row1 = ['加油站', '日期', '订单类型', '油品', '罐号', '空容', '车号', '所用车辆仓号', '仓容积', '不容纳时间点', '断货时间点', '预计发车时间', '在途时间']
      datas[0].data.push(row1)
      this.showData.forEach(function (item) {
        datas[0].data.push(item)
      })
      outPutExcelFile(datas, '每日订单（9月14日）.xls')
    },
    changeCar (index, chat = false) {
      this.chat = chat
      this.change_index = this.change_index === index ? -1 : index
    },
    pageChange (currentPage) {
      this.start_index = (currentPage - 1) * this.row_num
    },
    handleSizeChange (pageSize) {
      this.row_num = pageSize
      this.start_index = 0
    },
    changeOneData (index, carId) {
      this.$store.dispatch('editOnePre', {index, carId})
      this.change_index = -1
    }
  },
  computed: {
    showData: {
      get () {
        return this.$store.getters.preCarData
      }
    },
    showOptions: {
      get () {
        let data = []
        let vm = this
        let cars = []
        this.showData.forEach(function (item) {
          cars.push(item[6])
        })
        this.carsInfo.forEach(function (item) {
          if (item[1].indexOf(vm.search_car) > -1 && item[0] === vm.quy && cars.indexOf(item[1]) === -1) {
            data.push(item)
          }
        })
        return data
      }
    },
    charData: {
      get () {
        let data = []
        let vm = this
        this.showData.slice(vm.start_index, vm.start_index + vm.row_num).forEach(function (item, index) {
          let oneData = {
            name: '订单' + (vm.start_index + index + 1),
            style1: {
              width: 0
            },
            style2: {
              width: 0
            },
            dh_date: item[9],
            brn_date: item[10]
          }
          let num1 = item[9].slice(3, 5) === '15' ? 48 : (item[9].slice(3, 5) === '14' ? 24 : 0)
          let isFull = item[10].slice(3, 5) !== '15'
          oneData.style1.width = (num1 + Number(item[9].slice(6, 8)) + Number(item[9].slice(9)) / 60) / 72 * 100 + '%'
          oneData.style2.width = (isFull ? 0 : (24 - (Number(item[10].slice(6, 8)) + Number(item[10].slice(9)) / 60)) / 72 * 100) + '%'
          data.push(oneData)
        })
        return data
      }
    },
    preStatus: {
      get () {
        return this.$store.getters.preStatus
      }
    },
    carsInfo: {
      get () {
        return this.$store.getters.carsInfo
      }
    }
  },
  created () {
    if (this.preStatus === 20) {
      this.$store.dispatch('loadCarsInfo')
      this.$store.dispatch('loadPreCarData')
    } else if (this.preStatus < 20) {
      this.$router.push({name: 'single'})
    }
  }
}
</script>

<style scoped lang="less">
@import '../style/base.less';
.table-tool {
  position: absolute;
  right: 1rem;
  top: 0.5rem;
  i {
    font-size: 1.3rem;
    margin-left: 1rem;
    color: #fff;
  }
}
.content-1-page {
  background: #fff;
  display: flex;
  justify-content: center;
  padding: 0.5em 0;
}
.two-content {
  width: 100%;
  display: flex;
  border-radius: 0.5em;
  padding: 0.88em 0.7em 2.25em;
  background-color: #e5e5e5;
}
.show-search {
  display: flex !important;
  z-index: 1000;
}
.select-cars-search {
  display: flex;
  padding: 0.3em 1em 0;
  border-bottom: 1px solid #fff;
  a {
    text-align: center;
    margin-left: 1em;
    margin-top: 0.3em;
    width: 1.2em;
    height: 1.2em;
    font-size: 1.5em;
    line-height: 1.2em;
    color: #081633;
    font-weight: 600;
    background: #fff;
    border-radius: 100%;
  }
}
.icon-change {
  color: #081633;
  padding-left: 0.2em;
}
.cars-infos-div {
  max-height: 20em;
  overflow: auto;
}
.cars-infos {
  color: #fff;
  display: flex;
  div {
    text-align: center;
    flex: 1;
  }
}
.cars-infos-th {
  color: #fff;
  display: flex;
  div {
    text-align: center;
    flex: 1;
  }
}
.cars-infos:hover {
  background-color: #081633;
}
.select-cars {
  position: absolute;
  top: 100%;
  width: 40em;
  display: none;
  color: #fff;
  z-index: 100;
  line-height: 2.5em;
  flex-direction:column;
  background-color: #012e53;
  border-radius: 0.3em;
  box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.3);
}
.car-data-id {
  position: relative;
  width: 9em;
}
.data-num:hover {
  .data-brn-note {
    display:block;
  }
}
.data-brn-note {
  position: relative;
  top: -3em;
  word-break:keep-all;
  white-space:nowrap; 
  height: 3em;
  display: none;
}
.car-data {
  display: flex;
  margin-top: 1.5em;
  flex-direction:column;
  width: 5em;
}
.one-car-data {
  width: 9em;
  position: relative;
  flex:1;
  display: flex;
  justify-content:center;
  align-items: center;
}

.data-xian-sned {
  flex: 1;
}
.data-none {
  flex:1;
  height: 1px;
  background-color: #999;
}
.data-num {
  width: 1.2em;
  flex: 1;
  height: 1em;
}
.data-send {
  background-color: #00ccff;
}
.data-brn {
  position: relative;
  background-color: #012e53;
}
.data-dh {
  background-color: #6b59cf;
}
.data-xian {
  display: flex;
  height: 100%;
  justify-content:center;
  align-items: center;
}
.y-top-note {
  height: 1.5em;
  width: 4em;
}
.chat-y-data {
  flex: 1;
  display: flex;
  flex-direction:column;
  margin: 1.5em 2em 0 0;
}
.chat-x {
  font-size: 0.88em;
  color: #081633;
  display: flex;
  margin-left: 3.45em;
  margin-right: 5em;
}
.one-x {
  text-align: center;
  flex: 1;
  border-top: 1px solid #999;
  border-right: 1px solid #999;
}
.one-x-last {
  border-right: 0px solid #999;
}
.one-y {
  border-right: 1px solid #999;
  height: 7em;
  display: flex;
  justify-content:center;
  align-items: center;
}
.chat-y-line {
  width: 3.5em;
  font-size: 0.88em;
  color: #081633;
  display: flex;
  flex-direction:column;
}
.data-one {
  flex: 1;
  display: flex;
}
.chat-y-data {
  display: flex;
  flex: 1;
  flex-direction:column;
}
.chat-y {
  display: flex;
  width: 100%;
}
.chat-info {
  margin-bottom: 2.7em;
  margin-left: 2.7em;
  display: flex;
  flex-direction:column-reverse;
}
.dian-1 {
  background-color: #00ccff;
}
.dian-2 {
  background-color: #012e53;
}
.dian-3 {
  background-color: #6b59cf;
}
.dian {
  width: 0.5em;
  height: 0.5em;
  margin-right: 1em;
}
.one-info {
  color: #081633;
  font-size: 0.88em;
  height: 2em;
  display: flex;
  align-items: center;
}
.chat-block {
  display: flex;
  width: 85%;
}
.chat-content {
  display: flex;
  flex: 1;
  flex-direction:column;
  padding: 2em;
}
.chat-title {
  color: #0b5591;
  line-height: 1;
  padding-left: 0.5em;
  font-size: 0.94em;
  border-left: 4px solid #0b5591;
}
.i-zhuan {
  transform: rotate(180deg);
}
.zhuang-span {
  transition: 1s;
}
.btn-top-jiao {
  width: 0;
  height: 0;
  border-bottom: 0.81em solid @bak-color-2;;
  border-left: 1.7em solid transparent;
}
.btn-bottom-jiao {
  width: 0;
  height: 0;
  border-top: 0.81em solid @bak-color-2;
  border-right: 1.7em solid transparent;
}
.content-2 {
  padding: 1.88em 2.7em 4.8em;
  display: flex;
  flex-direction:column;
  background: #fff;
  border-radius: 0.5em;
  border-top: 2px dashed #bbb;
}

.content-1-table-1 {
  width: 68%;
}
.content-1-table-2 {
  flex: 1;
  background:#fff;
  margin-left: 0.7em;
  display: flex;
  flex-direction:column;
}
.content-1 {
  background: #fff;
  display: flex;
  flex-direction:column;
}
.content-1-1 {
  background:#fff;
  width: 40%;
  margin-right: 1em;
}
.content-1-2 {
  background:#fff;
  flex: 1;
}
.content-1-tables {
  display: flex;
}
.mii-table-1 {
  background-color: @bak-color-td-2;
}
.mii-table-2 {
  background-color: @bak-color-td-1;
}
.pagination-table {
  text-align: right;
  margin-right: 0.5em;
}
.mii-table {
  .content-shadow;
  .content-top-radius;
  display: flex;
  position: relative;
  flex-direction:column;
  box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.3);
  .data-td {
    width: 10%;
  }
  .s-bak-td {
    background-color: #e0e6ea;
    border:0 solid @bak-color-main;
  }
  .jj-bak-td {
    background-color: @bak-color-2;
    color: #00ccff;
  }
  .ps-bak-td {
    background-color: #98aab9;
  }
  table {
    border-spacing: 0px;
    width: 100%;
    th {
      border:0.2px solid @bak-color-main;
      text-align: center;
      font-size: 0.8em;
      line-height: 2.5em;
      color: @bak-color-1;
      font-weight: 100;
      height: 2em;
      word-break:keep-all;
      white-space:nowrap;
      text-overflow:ellipsis;
    }
    td {
      word-break:keep-all;
      white-space:nowrap;
      text-overflow:ellipsis; 
      height: 2.5em;
      border:0.2px solid @bak-color-main;
      text-align: center;
      font-size: 0.8em;
      color: @bak-color-1;
    }
  }
}
</style>

<style lang="less">
.prediction-car-page .two-content .el-select .el-input .el-input__icon {
  background: rgba(0,0,0,0)
}
</style>



// WEBPACK FOOTER //
// prediction_station.vue?01452e58